import axios from "axios";
import { errCodes } from "../response/errors";
import Response from "../response";
import { WEBSCRAPERS_API_BASE_URL } from "../../utils/constants";

class WebscrapersService {
  constructor() {
    this.baseUrl = WEBSCRAPERS_API_BASE_URL;
    this.url = `${this.baseUrl}`;
  }

  async authorize(orgID, siteID, credentialID) {
    try {
      const formData = new FormData();
      formData.append("org_id", orgID);
      formData.append("site_id", siteID);
      formData.append("credential_id", credentialID);

      const response = await axios({
        url: `${this.url}/authorize`,
        method: "POST",
        data: formData,
      });

      return Response.create(response.data, true);
    } catch (error) {
      return Response.create({}, false, {"error": error}, errCodes.Internal);
    }
  }
}

export default WebscrapersService;